export default "__VITE_ASSET__7vmIjrYI__"